import React from 'react'
import { mapPage, mapMetaData } from '../../utils/mapper'
import ShotContent from '../../components/shot'
import { withStyles } from '@material-ui/core/styles'
import styles from '../../styles/site'

const Shot = props => {
  const { policies } = props
  const metadata = mapMetaData(props.data.shot)
  const data = mapPage(props.data.shot)
  return (
    <div>
      <ShotContent data={data} metadata={metadata} policies={policies} />
    </div>
  )
}

export default withStyles(styles)(Shot)

export const query = graphql`
  query shotTypeQuery($id: String!) {
    shot: prismicCtShot(id: { eq: $id }) {
      ...shot
    }
    policies: allPrismicCtDoc {
      edges {
        node {
          uid
          data {
            title {
              text
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/shot/shot.js